// src/auth/msalInstance.js
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

let initialized  = false;
let initPromise  = null;

/** Must resolve before MsalProvider renders or any MSAL API is called. Call once at bootstrap. */
export function ensureMsalInitialized() {
  if (initialized) return Promise.resolve();
  if (!initPromise) {
    initPromise = msalInstance.initialize().then(() => {
      initialized = true;
      // Picks up the redirect response (if returning from Entra) before anything renders.
      return msalInstance.handleRedirectPromise().then(() => undefined);
    });
  }
  return initPromise;
}
